module.exports = __webpack_public_path__ + "static/media/G_S.c1ca5ff6.png";